import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import { toast, ToastContainer } from "react-toastify";
import { getTrans as t } from "../../../Localization/translations";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

const EditTermCondition = ({ id, onClose, refresh }) => {
  const form = useRef();
  const checkBtn = useRef();
  const [termsList, setTermsList] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    value: "",
  });

  // ✅ FETCH DATA
  useEffect(() => {
    axios
      .get(`${API}contracts/terms/${id}/`, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.data.success === 1) {
          setFormData(res.data.response);
        }
      })
      .catch(() => toast.error("Failed to load term"));
  }, [id]);

  useEffect(() => {
    axios
      .get(`${API}company/term-conditions/`, {
        headers: authHeader(),
      })
      .then((res) => {
        setTermsList(res.data || []);
      })
      .catch(() => toast.error("Failed to load terms list"));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ UPDATE
  const handleUpdate = (e) => {
    e.preventDefault();   // ✅ STOP PAGE RELOAD

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      axios
        .post(`${API}contracts/terms/${id}/update/`, formData, {
          headers: authHeader(),
        })
        .then((res) => {
          if (res.data.success === 1) {
            toast.success("Term updated successfully");

            refresh();

            setTimeout(() => {
              onClose();
            }, 1000);
          }
        })
        .catch(() => toast.error("Error updating term"));
    }
  };

  return (
    <>
      <ToastContainer />

      <div className="row py-2">
        <div className="col-md-12">

          {/* ✅ HEADER SAME */}
          <div className="header pb-0 mb-2">
            <h5 className="mb-0">{t("Edit Term & Condition")}</h5>
          </div>

          {/* ✅ CARD SAME */}
          <div className="card">
            <div className="card-body">

              <Form ref={form} onSubmit={handleUpdate}>

                <div className="row">

                  {/* NAME */}
                  <div className="col-md-6 mt-2">
                    <label className="col-form-label required">
                      {t("Name")}{" "}
                      <Tooltip content={t("Name_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>

                    <select
                      className="form-control"
                      value={formData.name}
                      onChange={(e) => {
                        const selectedName = e.target.value;
                        const selected = termsList.find((t) => t.name === selectedName);

                        setFormData((prev) => ({
                          ...prev,
                          name: selectedName,
                          value: prev.value || selected?.value || "", // ✅ KEEP EXISTING VALUE
                        }));
                      }}
                    >
                      <option value="">{t("Select")}</option>

                      {termsList.map((term) => (
                        <option key={term.id} value={term.name}>
                          {term.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* VALUE */}
                  <div className="col-md-6 mt-2">
                    <label className="col-form-label required">
                      {t("Value")}{" "}
                      <Tooltip content={t("Value_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>

                    <textarea
                      name="value"
                      className="form-control"
                      value={formData.value}
                      onChange={handleChange}
                    />
                  </div>

                  {/* BUTTONS */}
                  <div className="col-md-12">
                    <div className="ms-auto my-auto mt-3">

                      <button
                        type="button"
                        className="btn btn-secondary mb-0"
                        onClick={onClose}
                        style={{ marginRight: "10px" }}
                      >
                        {t("Cancel")}
                      </button>

                      <button
                        type="button"
                        className="btn btn-primary mb-0"
                        onClick={handleUpdate}
                      >
                        {t("Update")}
                      </button>

                      <CheckButton style={{ display: "none" }} ref={checkBtn} />
                    </div>
                  </div>

                </div>
              </Form>

            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default EditTermCondition;